<router-outlet></router-outlet>

<div [hidden]="!(isLoading | async)">
  <div class="loading-spinner-overlay">
    <div class="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
